import React from 'react';
import {GraphViewKind} from '../../../../../../components/graph/interface';
import {NeighborhoodGraphDirection} from '../interface';

export function useNeighborhoodGraphSettings() {
    const [viewKind, setViewKind] = React.useState(GraphViewKind.IDENTICAL);
    const toggleSelectedViewKind = React.useCallback(() => {
        setViewKind((prevState) =>
            prevState === GraphViewKind.IDENTICAL ? GraphViewKind.MERGED : GraphViewKind.IDENTICAL
        );
    }, []);
    const [maxDistance, setMaxDistance] = React.useState(3);
    const [direction, setDirection] = React.useState(NeighborhoodGraphDirection.OUTGOING);

    return {
        viewKind,
        toggleSelectedViewKind,
        maxDistance,
        setMaxDistance,
        direction,
        setDirection
    };
}
